// Shared "page size" options for rsuite pagination/select controls, scaled to
// the current row count so a picker never offers options far larger than the
// data (e.g. "200 per page" when there are 12 rows) and never shows a blank
// "Select" placeholder because the current value isn't one of the options.
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 200];

/**
 * Only offer options smaller than `total`, plus the first option that covers
 * them all. Always returns at least one option.
 * @param {number} total
 * @param {number[]} [options]
 * @returns {number[]}
 */
export function getLimitOptions(total, options = DEFAULT_PAGE_SIZE_OPTIONS) {
  const opts = options.filter((o) => o < total);
  const cap = options.find((o) => o >= total);
  if (cap) opts.push(cap);
  return opts.length ? opts : [options[0]];
}
